import { useState, useEffect } from "react";
import "./ControlProductDetails.scss";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { projectFirestore } from "../../firebase-config/config";
import { MDBCol, MDBRow, MDBCardText } from "mdb-react-ui-kit";
import ReactSwitch from "react-switch";

const ControlProductDetails = () => {
  const { user } = useAuthContext();

  const { updateDocument } = useFirestore("settings");
  const [activeField, setActiveField] = useState("");

  const { document: fieldTypeDoc } = useDocument(
    "settings",
    "productDetailsVisibility"
  );

  useEffect(() => {
    setActiveField(fieldTypeDoc);
  }, [fieldTypeDoc]);

  const fieldsTypeLabels = {
    productName: "Product Name",
    productCategory: "Product Category",
    productBrand: "Product Brand",
    productModel: "Product Model",
    productSKU: "Product SKU",
    productHSN: "Product HSN",
    productRating: "Product Rating",
    productPrice: "Product Price",
    productDiscount: "Product Discount",
    productShortDescription: "Short Description",
    productPreview: "Product Preview",
    productFeatures: "Product Features",
    productDescription: "Product Full Description",
    GST: "GST",
    deliverablePincodes: "Pin Code",
  };

  const handleToggleChange = async (fieldName, currentValue) => {
    try {
      if (fieldTypeDoc) {
        // Update existing doc
        await updateDocument("productDetailsVisibility", {
          [fieldName]: currentValue,
        });
      } else {
        // First create the document, then update the field
        await projectFirestore
          .collection("settings")
          .doc("productDetailsVisibility")
          .set({ [fieldName]: currentValue }); // create with initial field
      }
    } catch (error) {
      console.error("Error updating product field visibility:", error);
    }
  };

  return (
    <div>
      <div className="">
        {user && user.roles.includes("admin") && (
          <div className="role">
            <div className="section-title">
              <p>Product Fields</p>
              <h2>Change Your Product Details Visibility</h2>
            </div>
            <div className="radio-container">
              {Object.entries(fieldsTypeLabels)
                .sort(([, labelA], [, labelB]) => labelA.localeCompare(labelB))
                .map(([fieldName, label]) => {
                  const isFieldAvailable =
                    activeField?.hasOwnProperty(fieldName);
                  const currentValue = isFieldAvailable
                    ? activeField[fieldName]
                    : false;
                  return (
                    <div
                      key={fieldName}
                      className="d-flex align-items-center justify-content-between"
                      style={{
                        border: "1px solid grey",
                        borderRadius: "7px",
                        margin: "8px 0px",
                        padding: "8px",
                      }}
                    >
                      <div>
                        <h6
                          style={{
                            fontWeight: "700",
                            color: "var(--heading-color)",
                          }}
                        >
                          {label}
                        </h6>
                        <p style={{ color: "var(--grey-dark)" }}>Visibility</p>
                      </div>

                      {/* ACTIVE INACTIVE SWITCH */}
                      <div style={{ margin: "0px 0px 20px 15px" }}>
                        <MDBRow>
                          <MDBCol className="col-9">
                            <MDBCardText className="text-muted">
                              <div className="d-flex align-items-center mt-2">
                                <ReactSwitch
                                  checked={currentValue}
                                  onChange={() =>
                                    handleToggleChange(fieldName, !currentValue)
                                  }
                                  onColor="#149AA2"
                                  offColor="#F05B83"
                                  className="products-status-switch"
                                />
                                <div>
                                  <p
                                    className="active-inactive-text"
                                    style={{ color: "red" }}
                                  >
                                    Unhide
                                  </p>
                                </div>
                              </div>
                            </MDBCardText>
                          </MDBCol>
                        </MDBRow>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
        <br />
        <p style={{ fontSize: "13px" }}>
          <span style={{ fontWeight: "bold", color: "var(--red-color)" }}>
            Note :
          </span>
          Product Fields Settings: You can hide or unhide your product detail
          fields according to your preference
        </p>
      </div>
    </div>
  );
};

export default ControlProductDetails;
